'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _getOwnPropertyDescriptor = require('babel-runtime/core-js/object/get-own-property-descriptor');

var _getOwnPropertyDescriptor2 = _interopRequireDefault(_getOwnPropertyDescriptor);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _objectWithoutProperties2 = require('babel-runtime/helpers/objectWithoutProperties');

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _get3 = require('lodash/get');

var _get4 = _interopRequireDefault(_get3);

var _desc, _value, _class, _class2, _temp;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _formAutosuggestInput = require('./formAutosuggestInput');

var _formAutosuggestInput2 = _interopRequireDefault(_formAutosuggestInput);

var _utils = require('helpers/utils');

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

var _components = require('components');

var _autobindDecorator = require('autobind-decorator');

var _autobindDecorator2 = _interopRequireDefault(_autobindDecorator);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) {
  var desc = {};
  Object['ke' + 'ys'](descriptor).forEach(function (key) {
    desc[key] = descriptor[key];
  });
  desc.enumerable = !!desc.enumerable;
  desc.configurable = !!desc.configurable;

  if ('value' in desc || desc.initializer) {
    desc.writable = true;
  }

  desc = decorators.slice().reverse().reduce(function (desc, decorator) {
    return decorator(target, property, desc) || desc;
  }, desc);

  if (context && desc.initializer !== void 0) {
    desc.value = desc.initializer ? desc.initializer.call(context) : void 0;
    desc.initializer = undefined;
  }

  if (desc.initializer === void 0) {
    Object['define' + 'Property'](target, property, desc);
    desc = null;
  }

  return desc;
}

var styles = require('./formTagsInput.scss');

var formTagsInput = (_class = (_temp = _class2 = function (_Component) {
  (0, _inherits3.default)(formTagsInput, _Component);

  function formTagsInput() {
    var _ref;

    (0, _classCallCheck3.default)(this, formTagsInput);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    var _this = (0, _possibleConstructorReturn3.default)(this, (_ref = formTagsInput.__proto__ || (0, _getPrototypeOf2.default)(formTagsInput)).call.apply(_ref, [this].concat(args)));

    _this.state = { selectedTag: null, focused: false };
    return _this;
  }

  (0, _createClass3.default)(formTagsInput, [{
    key: 'onTagClick',
    value: function onTagClick(tag) {
      this.setState({ selectedTag: tag });
    }
  }, {
    key: 'onKeyDown',
    value: function onKeyDown(e) {
      var tags = this.props.tags;
      var selectedTag = this.state.selectedTag;


      if (!e.target.value) {
        if (e.which === 8 && tags.length) {
          var lastTag = tags[tags.length - 1];
          if (selectedTag === lastTag) {
            this.deleteTag(selectedTag);
          } else {
            this.setState({ selectedTag: lastTag });
          }
        }
      } else {
        this.unselectTag();
      }
    }
  }, {
    key: 'getInputProps',
    value: function getInputProps() {
      var _this2 = this;

      var _props$input = this.props.input,
          input = _props$input === undefined ? {} : _props$input;


      return (0, _extends3.default)({}, input, {
        onFocus: function onFocus(e) {
          (0, _get4.default)(input, 'onFocus', function () {})(e);
          _this2.setState({ focused: true });
        },
        onBlur: function onBlur(e) {
          (0, _get4.default)(input, 'onBlur', function () {})(e);
          _this2.setState({ focused: false });
        }
      });
    }
  }, {
    key: 'unselectTag',
    value: function unselectTag() {
      this.setState({ selectedTag: null });
    }
  }, {
    key: 'deleteTag',
    value: function deleteTag(tag) {
      var _this3 = this;

      var deletingTag = this.state.deletingTag;

      if (deletingTag === tag) {
        return false;
      }

      var onTagDelete = this.props.onTagDelete;


      if (onTagDelete) {
        this.setState({ deletingTag: tag });
        onTagDelete(tag).then(function () {
          return _this3.setState({ deletingTag: null });
        }).catch(function () {
          return _this3.setState({ deletingTag: null });
        });
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var _props = this.props,
          tags = _props.tags,
          tagNameField = _props.tagNameField,
          tagKeyField = _props.tagKeyField,
          inputClassName = _props.inputClassName,
          other = (0, _objectWithoutProperties3.default)(_props, ['tags', 'tagNameField', 'tagKeyField', 'inputClassName']);
      var _state = this.state,
          selectedTag = _state.selectedTag,
          deletingTag = _state.deletingTag,
          focused = _state.focused;

      var input = this.getInputProps();

      var onKeyDown = other.onKeyDown;

      other.onKeyDown = function (e) {
        if (onKeyDown) {
          onKeyDown(e);
        }
        _this4.onKeyDown(e);
      };

      return _react2.default.createElement(
        'label',
        { className: (0, _classnames2.default)(styles.tagsInput, 'tagsInput', inputClassName, (0, _defineProperty3.default)({}, styles.focused, focused)), onClick: this.unselectTag },
        tags.map(function (tag) {
          var _classNames2;

          return _react2.default.createElement(
            'span',
            {
              key: tag[tagKeyField],
              className: (0, _classnames2.default)(styles.tag, (_classNames2 = {}, (0, _defineProperty3.default)(_classNames2, styles.selected, selectedTag === tag), (0, _defineProperty3.default)(_classNames2, styles.deleting, deletingTag === tag), _classNames2)),
              onClick: function onClick(e) {
                return (0, _utils.stopEvent)(e) && _this4.onTagClick(tag);
              }
            },
            tag[tagNameField],
            _react2.default.createElement(
              'span',
              { className: styles.closer, onClick: function onClick() {
                  return _this4.deleteTag(tag);
                } },
              _react2.default.createElement('i', { className: 'icon-close' }),
              deletingTag === tag && _react2.default.createElement(_components.Loader, { small: true, mask: true, transparent: true })
            )
          );
        }),
        (0, _formAutosuggestInput2.default)((0, _extends3.default)({}, other, { input: input, fieldClassName: styles.autosuggest, autoWidth: true }))
      );
    }
  }]);
  return formTagsInput;
}(_react.Component), _class2.propTypes = {
  input: _propTypes2.default.object,
  inputClassName: _propTypes2.default.string,
  onTagDelete: _propTypes2.default.func,
  tagKeyField: _propTypes2.default.string,
  tagNameField: _propTypes2.default.string,
  tags: _propTypes2.default.array
}, _temp), (_applyDecoratedDescriptor(_class.prototype, 'unselectTag', [_autobindDecorator2.default], (0, _getOwnPropertyDescriptor2.default)(_class.prototype, 'unselectTag'), _class.prototype)), _class);
exports.default = formTagsInput;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/formComponents/formTagsInput.js
// module id = 2139
// module chunks = 1